var Flickity = require('flickity');
const footerSlider = jQuery('.sponsor-strip__carousel'),
    footerSlides = jQuery('.sponsor-strip__carousel .sponsor-strip__sponsor')

if (footerSlider.length > 0 && footerSlides.length > 1) {


     var carousel = footerSlider.flickity({
        autoPlay: false,
        prevNextButtons: true,
        cellSelector: '.sponsor-strip__sponsor',
        pageDots     : true,
        lazyLoad     : true,
        resize       : true,
        groupCells   : true,
        draggable    : true,
        // wrapAround   : true,
        setGallerySize: true,
        cellAlign    : 'left',
        // contain: true,
        arrowShape   : {
                    x0: 30,
                    x1: 55, y1: 30,
                    x2: 65, y2: 30,
                    x3: 40
                },

     });

     // jQuery(".award-block").addClass("pageloaded");
     //
     // let container =  jQuery('.sponsor-strip');
     // // previous
     // jQuery('.button--previous', container).on( 'click', function() {
     //     carousel.flickity('previous');
     // });
     // jQuery('.button--previous', container).on( 'keypress', function(e) {
     //     if(e.which == 13) {
     //         carousel.flickity('previous');
     //     }
     // });
     // // next
     // jQuery('.button--next', container).on( 'click', function() {
     //     carousel.flickity('next');
     // });
     // jQuery('.button--next', container ).on( 'keypress', function(e) {
     //     if(e.which == 13) {
     //         carousel.flickity('next');
     //     }
     // });
}
